export const LOGO_URL = "https://logos.uniwhales.io";
export const SOLSCAN_URL = "https://solscan.io";
